"use client";


import SectionPage from "@/components/common/section-page";

import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, } from "@/components/ui/breadcrumb"
import CardTitle from "@/components/common/card-title";
import AwesomeCard from "@/components/common/awesome-card";
import ImageGallery from "@/components/common/image-gallery";
import EventCard from "@/components/common/event-card";

export default function Home() {

    return (
        <div className={"flex flex-col gap-6 pb-6 bg-slate-100"}>
            <CardTitle title={"Evènements"} backgroundImgSrc={"/images/card-title/agenda.jpg"} />


            <SectionPage sectionType="2xl">
                <div className={"flex justify-between items-center"}>
                    <Breadcrumb>
                        <BreadcrumbList>
                            <BreadcrumbItem>
                                <BreadcrumbLink href={"/"}>Evènements</BreadcrumbLink>
                            </BreadcrumbItem>
                        </BreadcrumbList>
                    </Breadcrumb>

                </div>
            </SectionPage>

            {/* Evenements */}
            <SectionPage sectionType="2xl">
                <AwesomeCard title={"Evènements 2026"} className={"bg-white"} titleClassName={"text-bleu-marine"}>
                    <div className={'mt-8'}>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
                            <EventCard
                                id={"siab-2026"}
                                title={"9ème SIAB – Semaine Internationale de l'Artisanat de Grand-Bassam"}
                                date={"30 juil. – 9 août 2026"}
                                image={"/images/agenda/EVENEMENT-SIAB-2026.jpg"}
                                location={"Maison du Patrimoine Culturel, Grand-Bassam"}
                                description={"La 9ᵉ édition de la Semaine Internationale de l'Artisanat de Grand-Bassam (SIAB), rendez-vous incontournable dédié à l'art et à l'artisanat d'art africains, se déroulera du 30 juillet au 09 août 2026 à la Maison du Patrimoine Culturel.\n\nVéritable plateforme de valorisation des savoir-faire africains, la SIAB est un événement culturel majeur qui contribue à la préservation du patrimoine culturel, à la promotion de la créativité du continent et au développement durable des industries culturelles et créatives."}
                                variant={"outline"}
                                bgColor={"secondary"}
                                className="h-full"
                            />
                            <EventCard
                                id={"miss-ete-2026"}
                                title={"Grande Finale Miss Été 2026"}
                                date={"Mercredi 5 août 2026 – 21h00"}
                                image={"/images/agenda/EVENEMENT-MISS-ETE-2026.jpg"}
                                location={"L'PAAS, Boulevard Latrille, Cocody Deux-Plateaux"}
                                description={"Événement phare de la saison estivale, l'élection de Miss Été 2026 promet une soirée d'exception placée sous le signe de l'élégance, du charme et de l'émotion.\n\nÀ cette occasion, 24 finalistes rivaliseront de grâce et de talent pour conquérir la prestigieuse couronne de Miss Été 2026.\n\nRendez-vous le mercredi 5 août 2026 à partir de 21h00, à L'PAAS, situé sur le Boulevard Latrille, Cocody Deux-Plateaux, pour vivre une soirée glamour et célébrer la beauté, l'élégance et le talent."}
                                variant={"outline"}
                                bgColor={"secondary"}
                                className="h-full"
                            />
                            <EventCard
                                id={"climbie-beach-2026"}
                                title={"Festival Climbié Beach 36 – Royaume d'Assinie"}
                                date={"7 – 16 août 2026"}
                                image={"/images/agenda/EVENEMENT-CLIMBIE-BEACH-2026.jpg"}
                                location={"Assinie Mafia, Côte d'Ivoire"}
                                description={"La 36ᵉ édition du Festival Climbié Beach se tiendra du 07 au 16 août 2026 à Assinie.\n\nVéritable rendez-vous de célébration du patrimoine, ce festival constitue une importante tribune d'expression dédiée à la valorisation des richesses touristiques, culturelles et coutumières du peuple Essouman du royaume d'Assinie. À travers ses nombreuses activités, il met en lumière les traditions ancestrales, l'identité culturelle et le potentiel touristique de cette destination emblématique de la Côte d'Ivoire."}
                                variant={"outline"}
                                bgColor={"secondary"}
                                className="h-full"
                            />
                            <EventCard
                                id={"festival-3a-2026"}
                                title={"Festival des Arts et Culture des 3A – 8ᵉ édition"}
                                date={"7 – 16 août 2026"}
                                image={"/images/agenda/EVENEMENT-FESTIVAL-3A-2026.jpg"}
                                location={"Jacqueville, Côte d'Ivoire"}
                                description={"Du 7 au 16 août, vivez la 8e édition du Festival des Arts et Culture des 3A !\n\nCulture, gastronomie, musique, danse et traditions au rendez-vous !"}
                                variant={"outline"}
                                bgColor={"secondary"}
                                className="h-full"
                            />
                            <EventCard
                                id={"discovery-tour-2026"}
                                title={"Discovery Tour – Édition 2"}
                                date={"8 août 2026"}
                                image={"/images/agenda/EVENEMENT-DISCOVERY-TOUR-2026.jpg"}
                                location={"Destination surprise"}
                                description={"Le Discovery Tour – Édition 2 se tiendra le 8 août 2026. Organisé par AIESEC Abidjan-Nord, cet événement propose une expérience immersive invitant les participants à découvrir les richesses culturelles et patrimoniales de la Côte d'Ivoire à travers une destination surprise. Cette journée de découverte, de partage et d'aventure sera rythmée par des visites, des activités ludiques et des rencontres authentiques, offrant une immersion unique au cœur des traditions locales."}
                                variant={"outline"}
                                bgColor={"secondary"}
                                className="h-full"
                            />
                            <EventCard
                                id={"yaou-festival-2026"}
                                title={"Yaou Festival – 9ᵉ édition"}
                                date={"14 – 16 août 2026"}
                                image={"/images/agenda/EVENEMENT-YAOU-FESTIVAL-2026.jpg"}
                                location={"Yaou, Route Bonoua"}
                                description={"Du 14 au 16 août 2026, le village de Yaou accueille la 9ᵉ édition du Yaou Festival, un rendez-vous culturel placé sous le signe de la musique, de la jeunesse et du vivre-ensemble.\n\nAu programme : zouglou, coupé-décalé, rétro, biama, rap ivoire et prestations d’artistes.\n\n🎯 Thème : « La contribution des jeunes au développement socio-économique »\n📍 Lieu : Yaou\n📅 Dates : 14 au 16 août 2026\n\nLe festival offre une occasion de découvrir Yaou à travers la musique, la culture et les rencontres, tout en contribuant au renforcement de la cohésion sociale."}
                                variant={"outline"}
                                bgColor={"secondary"}
                                className="h-full"
                            />
                            <EventCard
                                id={"promenade-culinaire-2026"}
                                title={"La Promenade Culinaire Abidjan"}
                                date={"2 – 11 octobre 2026"}
                                image={"/images/agenda/EVENEMENT-PROMENADE-CULINAIRE-2026.jpg"}
                                location={"Abidjan, Côte d'Ivoire"}
                                description={"Du 2 au 11 octobre 2026, Abidjan accueille La Promenade Culinaire, une expérience gastronomique proposée par COWAF.\n\n🍽️ Au programme : 17 escales gourmandes dans plusieurs restaurants et adresses emblématiques d’Abidjan, parmi lesquels Pullman, Le Lof, Casa Ekwa, Sofitel, Villa Le Prisé et bien d’autres.\n\n📍 Lieu : Abidjan\n📅 Dates : 2 au 11 octobre 2026\n🍴 17 escales gourmandes\n\nUne occasion de découvrir Abidjan à travers sa gastronomie, ses restaurants et la diversité de ses expériences culinaires."}
                                variant={"outline"}
                                bgColor={"secondary"}
                                className="h-full"
                            />
                        </div>
                    </div>
                </AwesomeCard>
            </SectionPage>

            <SectionPage sectionType="2xl">
                {/* Evenements 2025 */}

                <AwesomeCard title={"Evènements 2025"} className={"bg-white"} titleClassName={"text-bleu-marine"}>
                    <div className={'mt-8'}>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
                            <EventCard
                                id={"0"}
                                title={"🧡🤍💚🌍 FIACT 2025 – Grand-Bassam ✨"}
                                date={"27 oct. – 7 jan. 2026"}
                                image={"/images/agenda/EVENEMENT-FIACT.jpeg"}
                                location={"Grand-Bassam, Côte d'Ivoire"}
                                description={"La Foire Internationale de l’Artisanat, de la Culture et du Tourisme (FIACT) revient pour sa 5ᵉ érème du 27 octobre 2025 au 07 janvier 2026 au Centre Artisanal de Grand-Bassam. 😍 Vivez une expérience unique au cœur de cette ville patrimoine, entre créativité, savoir-faire et traditions ! 手数🎭\n\nAu programme :\n✨ Expositions d’artisanat et d’arts contemporains\n🎶 Prestations artistiques et culturelles\n🖼️ Découvertes et circuits touristiques dans la ville musée\n🎁 Souvenirs et objets d’art faits main"}
                                variant={"outline"}
                                bgColor={"secondary"}
                                className="h-full"
                            />
                            
                            <EventCard
                                id={"0"}
                                title={"🎉🇨🇮 Sahoua Festival 5 – M’Batto 🎭"}
                                date={"28 – 30 oct. 2025"}
                                image={"/images/agenda/EVENEMENT-SAHOUA.jpeg"}
                                location={"M’Batto, Moronou, Côte d'Ivoire"}
                                description={"Du 28 au 30 octobre 2025, venez célébrer la culture sahoua à l’Espace Gravier, M’Batto ! ✨\n\nSous le thème : « Art & Culture, vecteurs de cohésion sociale et de développement local »\n\nAu programme :\n✨ Danses traditionnelles | 🍲 Cuisine & beauté | 🧺 Exposition du terroir\n🎶 Concerts | 🏞️ Visites touristiques | 💃🏾 Parade et animations\n\n📞 Infos : 0757411909 / 0507870735\n\n#SahouaFestival #Mbatto #Moronou #CultureIvoirienne #TourismeCI #FestivalCulturel #ArtEtCulture #CôtedIvoireTourisme"}
                                variant={"outline"}
                                bgColor={"secondary"}
                                className="h-full"
                            />
                            
                            <EventCard
                                id={"0"}
                                title={"Africa Foto Fair 2025 – Grand-Bassam, Côte d’Ivoire"}
                                date={"12 nov. – 7 déc. 2025"}
                                image={"/images/agenda/africa-foto-fair-2025.jpg"}
                                location={"Grand-Bassam, Côte d'Ivoire"}
                                description={"Festival mettant à l’honneur les talents africains de la photographie : expositions, conférences et ateliers."}
                                variant={"outline"}
                                bgColor={"secondary"}
                                className="h-full"
                            />
                            <EventCard
                                id={"1"}
                                title={"DAVIDO – 5IVE TOUR AFRICA – Abidjan"}
                                date={"Vendredi 29 novembre 2025"}
                                image={"/images/agenda/davido-concert.jpg"}
                                location={"Parc des Expositions, Abidjan"}
                                description={"Concert géant du roi de l’Afrobeat, Davido. Infos & réservations : 07 67 08 00 00 | Soutenu par Côte d’Ivoire Tourisme"}
                                variant={"outline"}
                                bgColor={"secondary"}
                                className="h-full"
                            />
                        </div>
                    </div>
                </AwesomeCard>
            </SectionPage>

            <SectionPage sectionType="2xl">
                {/* Evenements 2023 */}
                <AwesomeCard title={"Evènements 2023"} className={"bg-white"} titleClassName={"text-bleu-marine"}>
                    <div className={'mt-8'}>
                        <ImageGallery images={[
                            {
                                src: "/images/agenda/JMT-2023.jpg",
                                alt: "JMT 2023",
                                width: 1000,
                                height: 1000
                            },
                            {
                                src: "/images/agenda/ABISSA-2023.jpg",
                                alt: "ABISSA 2023",
                                width: 1000,
                                height: 1000
                            }
                        ]} gridClassName={"grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-12"} />
                    </div>
                </AwesomeCard>
            </SectionPage>
        </div>
    );
}
